import { render, staticRenderFns } from "./JEditableTable.vue?vue&type=template&id=8b562922&scoped=true"
import script from "./JEditableTable.vue?vue&type=script&lang=js"
export * from "./JEditableTable.vue?vue&type=script&lang=js"
import style0 from "./JEditableTable.vue?vue&type=style&index=0&id=8b562922&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b562922",
  null
  
)

export default component.exports